import { jsx as _jsx } from "react/jsx-runtime";
import { useCustomerDetail } from '~/hooks/reactQuery/queries/useCustomerDetail';
import { ClientDetailPageView } from './ClientDetailPageView';
export function ClientDetailPageCustomersOld(param) {
    let { clientId } = param;
    const detail = useCustomerDetail(clientId, {
        refreshOnHookMount: true
    });
    return /*#__PURE__*/ _jsx(ClientDetailPageView, {
        clientId: clientId,
        detail: detail,
        onArchiveOrRestoreSucceeded: detail.refresh
    });
}
